<div class="container-fluid">
  <!-- Page Header with Utility Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Weekly Schedule Totals</h1>

    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <div class="d-flex flex-wrap gap-1">
        <button
          style="color:#000; background-color: #82CFFD !important; border-color: #82CFFD !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="fetch()">
          Refresh
        </button>
        <button
          style="color:#fff; background-color: #0AC92B !important; border-color: #0AC92B !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="exportReport()">
          <mat-icon>file_download</mat-icon>
          <span>Export</span>
        </button>
        <button style="background-color: transparent !important; border: none;"
          (click)="printReport()"
          type="button"
          mat-icon-button
          class="me-1 mb-1"
          matTooltip="Print weekly schedule totals report"
          matTooltipPosition="below"
          aria-label="Print weekly schedule totals report">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Filter</mat-panel-title>
    </mat-expansion-panel-header>

    <form #f="ngForm" class="form">
      <div class="row align-items-center">
        <app-week-year-selector
          [initialWeek]="week"
          [initialYear]="year"
          (selectionChange)="onWeekYearChange($event)">
        </app-week-year-selector>

        <div class="col-md-3 mb-2">
          <label class="form-label small text-muted d-block">Scope</label>
          <mat-button-toggle-group [value]="scope" (change)="onScopeChange($event.value)" aria-label="Scope">
            <mat-button-toggle value="studio">Studio</mat-button-toggle>
            <mat-button-toggle value="staff">Staff</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div class="col-md-3 mb-2">
          <label class="form-label small text-muted d-block">Count Basis</label>
          <mat-button-toggle-group [value]="countBasis" (change)="onCountBasisChange($event.value)" aria-label="Count basis">
            <mat-button-toggle value="scheduled">Scheduled</mat-button-toggle>
            <mat-button-toggle value="taken">Taken</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </form>
  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!loading" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="errorMessage" class="alert alert-danger mt-3">{{ errorMessage }}</div>

  <ng-container *ngIf="response && !loading">
    <div *ngIf="response.grids.length === 0" class="alert alert-info mt-3">
      No events scheduled for this week.
    </div>

    <div class="row">
      <div class="col-12 mt-4" *ngFor="let grid of response.grids">
        <h3 *ngIf="grid.instructor_name">{{ grid.instructor_name }}</h3>
        <p *ngIf="grid.instructor_name" class="mb-2">
          Total Events: {{ grid.grand_total }}
          <span *ngIf="grid.grand_total_cancelled" class="text-muted">&middot; {{ cancelledText(grid.grand_total_cancelled) }}</span>
        </p>

        <table mat-table [dataSource]="visibleRows(grid)" class="w-100 mat-elevation-z8">

          <!-- Category column -->
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef class="border">Staff Member \ Studio</th>
            <td mat-cell *matCellDef="let row" class="border">{{ row.label }}</td>
            <td mat-footer-cell *matFooterCellDef class="border"><strong>Daily Total Lessons</strong></td>
          </ng-container>

          <!-- One column per weekday. Each cell stacks the count over a small
               muted "n cancelled" line that appears only when n > 0. -->
          <ng-container *ngFor="let d of dayKeys; let i = index" [matColumnDef]="d">
            <th mat-header-cell *matHeaderCellDef class="border text-center">
              <ng-container *ngIf="i === 0; else plainDay">Daily Count<br><small>({{ dayLabels[i] }})</small></ng-container>
              <ng-template #plainDay>{{ dayLabels[i] }}</ng-template>
            </th>
            <td mat-cell *matCellDef="let row" class="border text-center align-top">
              {{ countText(cell(grid, row.key, d), cancelledCell(grid, row.key, d)) }}
              <small *ngIf="cancelledCell(grid, row.key, d) as n" class="d-block text-muted text-nowrap">{{ cancelledText(n) }}</small>
            </td>
            <td mat-footer-cell *matFooterCellDef class="border text-center align-top">
              <strong>{{ dailyLessonTotal(grid, d) }}</strong>
              <small *ngIf="dailyLessonCancelled(grid, d) as n" class="d-block text-muted text-nowrap">{{ cancelledText(n) }}</small>
            </td>
          </ng-container>

          <!-- Row total column -->
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef class="border text-center">Total</th>
            <td mat-cell *matCellDef="let row" class="border text-center align-top">
              <strong>{{ countText(rowTotal(grid, row.key), cancelledRowTotal(grid, row.key)) }}</strong>
              <small *ngIf="cancelledRowTotal(grid, row.key) as n" class="d-block text-muted text-nowrap">{{ cancelledText(n) }}</small>
            </td>
            <td mat-footer-cell *matFooterCellDef class="border text-center align-top">
              <strong>{{ lessonGrandTotal(grid) }}</strong>
              <small *ngIf="lessonGrandCancelled(grid) as n" class="d-block text-muted text-nowrap">{{ cancelledText(n) }}</small>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>
    </div>
  </ng-container>
</div>
